/**
 * CONFIGURADOR TREKKO — motor de letras
 * Usado pela Luminaria Balao. Funil: Cor > Tipo de personalizacao > Letra(s)
 *
 * Modelo de integracao (identico ao Acalanto): o configurador ALIMENTA os
 * seletores nativos de variante do tema (renderizados porem ocultos via CSS).
 * O reader do tema (<product-form>) escuta 'change' nesses inputs
 * [name^="options"], recalcula a variante, atualiza o [name="id"] e troca a
 * imagem nativamente. Nao reinventamos esse mecanismo — so o acionamos.
 *
 * O QUE VIRA PROPERTY
 * So o que a variante NAO carrega, senao o carrinho mostra a mesma
 * informacao duas vezes:
 *   - Letra unica (A-Z) e "Sem Letra" ja estao no titulo da variante
 *     ("Branco / C") → NAO gravamos property.
 *   - "Duas Letras" e "Letra ❤ Letra" nao: a variante so diz o FORMATO,
 *     as letras reais existem apenas na property → gravamos, e ela e a
 *     unica fonte para a producao.
 *   - Cor: so quando o produto ainda nao tem variantes.
 * Sem variantes (temVariantes = false), gravamos tudo.
 */
(function () {
  'use strict';

  var cfg = window.TREKKO_CFG || {};
  var temVariantes = cfg.temVariantes === true;
  var propLetras = cfg.propLetras || 'Letras';
  var propCor = cfg.propCor || 'Cor';
  var variantMap = window.TREKKO_VARIANTS || {};

  var estado = {
    cor: null,
    tipo: null,
    letra: null,
    letrasTexto: ''
  };

  /* ---- helpers ---- */

  function getEtapa(n) {
    return document.querySelectorAll('.ac-etapa')[n - 1];
  }

  function atualizarValorHeader(etapa, texto) {
    var el = etapa.querySelector('.ac-etapa-valor');
    if (el) el.textContent = texto || '';
  }

  function getPersonalizacaoVariante() {
    if (estado.tipo === 'uma-letra') return estado.letra;
    if (estado.tipo === 'duas-letras') return 'Duas Letras';
    if (estado.tipo === 'letra-coracao') return 'Letra ❤ Letra';
    if (estado.tipo === 'sem-letra') return 'Sem Letra';
    return null;
  }

  /* A variante guarda as letras de verdade? Para letra unica e sem letra,
     sim. Para as opcoes de duas letras, nao — ela so diz o formato. */
  function varianteGuardaAsLetras() {
    return estado.tipo === 'uma-letra' || estado.tipo === 'sem-letra';
  }

  function setNativeOption(pos, value) {
    if (value == null) return false;
    var nodes = document.querySelectorAll('[name^="options"][data-index="option' + pos + '"]');
    if (!nodes.length) return false;

    if (nodes.length === 1) {
      var inp = nodes[0];
      inp.value = value;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    var achou = false;
    nodes.forEach(function (n) {
      if (n.value === value) {
        n.checked = true;
        n.dispatchEvent(new Event('change', { bubbles: true }));
        achou = true;
      } else {
        n.checked = false;
      }
    });
    return achou;
  }

  function selecionarVariante() {
    if (!temVariantes) return;

    if (estado.cor) setNativeOption(1, estado.cor);

    var pers = getPersonalizacaoVariante();
    if (pers) setNativeOption(2, pers);

    if (estado.cor && pers) {
      var id = variantMap[estado.cor + '|' + pers];
      if (id) {
        var idInput = document.querySelector('[name="id"]');
        if (idInput && idInput.value !== String(id)) idInput.value = id;
      }
    }
  }

  function getForm() {
    return document.querySelector('form.product-form') ||
           document.querySelector('form[action*="/cart/add"]') ||
           document.querySelector('form[id^="ProductForm"]');
  }

  function setProp(form, nome, valor) {
    var existente = form.querySelector('[name="properties[' + nome + ']"]');
    if (existente) existente.parentNode.removeChild(existente);
    if (!valor) return;
    var inp = document.createElement('input');
    inp.type = 'hidden';
    inp.name = 'properties[' + nome + ']';
    inp.value = valor;
    form.appendChild(inp);
  }

  function injetarPropriedades() {
    var form = getForm();
    if (!form) return;

    var val = null;
    if (!temVariantes) {
      /* Sem variante, a property e a unica fonte de tudo. */
      val = estado.tipo === 'uma-letra' ? estado.letra : estado.letrasTexto;
    } else if (!varianteGuardaAsLetras()) {
      /* So os formatos de duas letras precisam da property. */
      val = estado.letrasTexto;
    }
    setProp(form, propLetras, val);

    setProp(form, propCor, temVariantes ? null : estado.cor);
  }

  function atualizarResumo() {
    function set(key, val) {
      var linha = document.querySelector('[data-resumo="' + key + '"]');
      var elVal = linha && linha.querySelector('.ac-resumo-val');
      if (!linha || !elVal) return;
      if (val) {
        elVal.textContent = val;
        linha.classList.remove('ac-resumo-pendente');
      } else {
        elVal.textContent = '---';
        linha.classList.add('ac-resumo-pendente');
      }
    }
    set('cor', estado.cor);
    var tipoLabel = estado.tipo === 'uma-letra' ? 'Uma Letra' :
                    estado.tipo === 'duas-letras' ? 'Duas Letras' :
                    estado.tipo === 'letra-coracao' ? 'Letra ❤ Letra' :
                    estado.tipo === 'sem-letra' ? 'Sem Letra' : null;
    set('tipo', tipoLabel);
    var letrasLabel = estado.tipo === 'uma-letra' ? estado.letra : estado.letrasTexto;
    set('letras', letrasLabel || null);
  }

  function revelarProxima(etapa) {
    var prox = etapa.nextElementSibling;
    while (prox) {
      if (prox.classList.contains('ac-etapa')) {
        prox.classList.add('ac-visivel');
        setTimeout(function () {
          prox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 80);
        break;
      }
      prox = prox.nextElementSibling;
    }
  }

  function concluirEtapa(etapa, texto) {
    etapa.classList.add('ac-concluida');
    atualizarValorHeader(etapa, texto);
    atualizarResumo();
    selecionarVariante();
    injetarPropriedades();
    revelarProxima(etapa);
  }

  /* ---- Etapa 1: Cor ---- */
  document.querySelectorAll('.ac-swatch').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.ac-swatch').forEach(function (b) { b.classList.remove('ac-sel'); });
      this.classList.add('ac-sel');
      estado.cor = this.dataset.cor;
      concluirEtapa(getEtapa(1), estado.cor);
    });
  });

  /* ---- Etapa 3: campos duplos ---- */
  var inpL1 = document.querySelector('.ac-input-l1');
  var inpL2 = document.querySelector('.ac-input-l2');
  var sepEl = document.querySelector('.ac-campo-sep');

  /* Separador entre as duas letras.
     Vazio para "Duas Letras": o "e" estava sendo lido como parte da
     gravacao ("A e N"), e o cliente nao sabia se a peca sairia com o E.
     So o formato coracao mantem simbolo, porque o ❤ e gravado na peca. */
  function separador() {
    return estado.tipo === 'letra-coracao' ? '❤' : '';
  }

  /* Monta o texto final das duas letras sem deixar espaco duplo quando
     nao ha separador. "Duas Letras" -> "A N"; coracao -> "A ❤ N". */
  function montarLetras(l1, l2) {
    var sep = separador();
    return sep ? l1 + ' ' + sep + ' ' + l2 : l1 + ' ' + l2;
  }

  function atualizarLetrasDuplas(colapsar) {
    if (!inpL1 || !inpL2) return;
    var l1 = inpL1.value.trim().toUpperCase();
    var l2 = inpL2.value.trim().toUpperCase();
    var etapa3 = getEtapa(3);

    if (l1 && l2) {
      estado.letrasTexto = montarLetras(l1, l2);
      atualizarValorHeader(etapa3, estado.letrasTexto);
      atualizarResumo();
      selecionarVariante();
      injetarPropriedades();
      etapa3.classList.remove('ac-destaque');
      if (colapsar) etapa3.classList.add('ac-concluida');
    } else {
      estado.letrasTexto = '';
      etapa3.classList.remove('ac-concluida');
      atualizarValorHeader(etapa3, '');
      atualizarResumo();
      injetarPropriedades();
    }
  }

  if (inpL1 && inpL2) {
    [inpL1, inpL2].forEach(function (inp, idx) {
      inp.addEventListener('input', function () {
        this.value = this.value.toUpperCase().replace(/[^A-ZÀ-Ü]/g, '');
        if (idx === 0 && this.value.length === 1) inpL2.focus();
        atualizarLetrasDuplas(false);
      });
      inp.addEventListener('blur', function () {
        setTimeout(function () {
          var ativo = document.activeElement;
          if (ativo !== inpL1 && ativo !== inpL2) {
            atualizarLetrasDuplas(true);
          }
        }, 150);
      });
    });
  }

  /* ---- Etapa 2: Tipo de personalizacao ---- */
  document.querySelectorAll('.ac-card-tipo').forEach(function (card) {
    card.addEventListener('click', function () {
      document.querySelectorAll('.ac-card-tipo').forEach(function (c) { c.classList.remove('ac-sel'); });
      this.classList.add('ac-sel');
      estado.tipo = this.dataset.tipo;
      estado.letra = null;
      estado.letrasTexto = '';

      var etapa3 = getEtapa(3);
      var grid = etapa3.querySelector('.ac-letras-grid');
      var campo = etapa3.querySelector('.ac-campo-letras');
      var titulo = etapa3.querySelector('.ac-etapa-titulo');

      etapa3.classList.remove('ac-concluida');
      etapa3.style.display = '';
      atualizarValorHeader(etapa3, '');
      document.querySelectorAll('.ac-btn-letra').forEach(function (b) { b.classList.remove('ac-sel'); });
      if (inpL1) inpL1.value = '';
      if (inpL2) inpL2.value = '';

      if (estado.tipo === 'sem-letra') {
        estado.letrasTexto = 'Sem letra';
        concluirEtapa(getEtapa(2), 'Sem Letra');
        etapa3.style.display = 'none';
        etapa3.classList.add('ac-concluida');
      } else if (estado.tipo === 'uma-letra') {
        if (grid) grid.style.display = 'flex';
        if (campo) campo.style.display = 'none';
        if (titulo) titulo.textContent = 'Qual letra?';
        concluirEtapa(getEtapa(2), 'Uma Letra');
      } else {
        if (grid) grid.style.display = 'none';
        if (campo) campo.style.display = 'block';
        if (titulo) titulo.textContent = 'Confirme as letras';
        /* Sem separador ("Duas Letras") o span some, senao sobraria
           um gap extra do flex entre os dois campos. */
        if (sepEl) {
          var sepTxt = separador();
          sepEl.textContent = sepTxt;
          sepEl.style.display = sepTxt ? '' : 'none';
        }
        concluirEtapa(getEtapa(2), estado.tipo === 'duas-letras' ? 'Duas Letras' : 'Letra ❤ Letra');
      }
      atualizarResumo();
    });
  });

  /* ---- Etapa 3: grade de letras (Uma Letra) ---- */
  document.querySelectorAll('.ac-btn-letra').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.ac-btn-letra').forEach(function (b) { b.classList.remove('ac-sel'); });
      this.classList.add('ac-sel');
      estado.letra = this.dataset.letra;
      concluirEtapa(getEtapa(3), estado.letra);
    });
  });

  /* ---- Reabrir etapa concluida ---- */
  document.querySelectorAll('.ac-etapa-header').forEach(function (header) {
    header.addEventListener('click', function () {
      var etapa = this.closest('.ac-etapa');
      if (!etapa || !etapa.classList.contains('ac-concluida')) return;
      etapa.classList.remove('ac-concluida');
      var prox = etapa.nextElementSibling;
      while (prox) {
        if (prox.classList.contains('ac-etapa')) {
          prox.classList.remove('ac-concluida', 'ac-visivel');
        }
        prox = prox.nextElementSibling;
      }
      var etapas = document.querySelectorAll('.ac-etapa');
      var idx = Array.prototype.indexOf.call(etapas, etapa);
      if (idx === 0) { estado.cor = null; estado.tipo = null; estado.letra = null; estado.letrasTexto = ''; }
      if (idx === 1) { estado.tipo = null; estado.letra = null; estado.letrasTexto = ''; }
      if (idx === 2) { estado.letra = null; estado.letrasTexto = ''; }
      atualizarResumo();
    });
  });

  /* ---- Proteger botao de compra ---- */
  function interceptarCompra(e) {
    var totalEtapas = document.querySelectorAll('.ac-etapa').length;
    var concluidas = document.querySelectorAll('.ac-etapa.ac-concluida').length;
    if (concluidas < totalEtapas) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var primeira = document.querySelector('.ac-etapa:not(.ac-concluida)');
      if (primeira) {
        primeira.scrollIntoView({ behavior: 'smooth', block: 'center' });
        primeira.classList.add('ac-destaque');
        setTimeout(function () { primeira.classList.remove('ac-destaque'); }, 1800);
      }
      return;
    }
    selecionarVariante();
    injetarPropriedades();
  }

  function bindBtnCompra() {
    var btns = document.querySelectorAll('[name="add"], [data-add-to-cart], .js-addtocart, button[data-action="add-to-cart"]');
    btns.forEach(function (btn) {
      if (!btn.dataset.acBound) {
        btn.dataset.acBound = '1';
        btn.addEventListener('click', interceptarCompra, true);
      }
    });
  }
  bindBtnCompra();
  setTimeout(bindBtnCompra, 500);
  setTimeout(bindBtnCompra, 1200);

  /* ---- Inicializacao ---- */
  var primeiraEtapa = document.querySelector('.ac-etapa');
  if (primeiraEtapa) primeiraEtapa.classList.add('ac-visivel');

})();